import React from 'react';
import { selectors, stateKeys } from '../../model';
import { useStoreSelector } from '../../hooks/useStoreSelector';
import { isFn } from '../../utils';
import styles from './GroupLabel.module.scss';

const renderSelector = (state) =>
  selectors.selectValue(state, stateKeys.renderOptionGroup);

const GroupLabel = ({ option }) => {
  const renderOptionGroup = useStoreSelector(renderSelector);

  return (
    <div className={styles.root}>
      {isFn(renderOptionGroup) ? renderOptionGroup(option) : option.label}
    </div>
  );
};

export default GroupLabel;
